import { api, registry } from './api';
import CacheStorage from './CacheStorage';

const baseURL = `${process.env.REACT_APP_API_URL}api`;

const cacheStorage = new CacheStorage();

const getCachedWorkSiteProject = async () => {
  const url = `${baseURL}/me/worksitesproject`;
  const items = await cacheStorage.getFromCache(url);
  return items || undefined;
};

const HocCardRepository = {
  updateCachedList: async (currentPage, pageSize, data) => {
    const url = `${baseURL}/hoccard/?page=${currentPage}&pageSize=${pageSize}`;
    const dataList = (await cacheStorage.getFromCache(url)) || {};
    let items = dataList.itemList || [];
    const element = items.find((el) => el.id === data.id);

    if (element == null) {
      items = items.concat(data);
    } else {
      items[items.indexOf(element)] = data;
    }
    dataList.itemList = items;
    await cacheStorage.updateCache(dataList, url);
  },
  updateCachedDetail: async (data) => {
    const url = `${baseURL}/hoccard/${data.id}`;
    await cacheStorage.updateCache(data, url);
  },
  getWorkSiteProject: async () =>
    (await getCachedWorkSiteProject()) || (await api.getAll(`${baseURL}/me/worksitesproject`)).data,

  preFetch: async () => {
    await api.getAll('/hoccard/?page=1&pageSize=10');
    await api.getAll(`${baseURL}/admin/hazardtype?page=0`);
    await api.getAll('/admin/hocpriority?page=0');
    await api.getAll('/admin/hoctype?page=0');
    await api.getAll('/admin/lifesavingrule?page=0');
    // api.getAll('/me/project');
    await api.getAll('/me/worksitesproject');
  },

  updateHocCardFilter: async data => {
    const url = `${baseURL}/hoccard/filter`;
    await cacheStorage.updateCache(data, url);
  },

  getBackPaged: async () => {
    const url = `${baseURL}/hoccard/filter`;
    const items = await cacheStorage.getFromCache(url);
    return items || undefined;
  }

};
export default HocCardRepository;
